import { FiMoreVertical } from "react-icons/fi";
import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import * as saarthiActions from "redux/actions/SaarthiActions";
import { makeStyles } from "@material-ui/core/styles";
import { useHistory, useLocation } from "react-router-dom";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import EnhancedTableHead from "../../common/enhancedTableHead"; // Common table action toolbar
import SearchBar from "material-ui-search-bar"; // searching bar
import ReactTooltip from "react-tooltip"; // React Tooltip
import VideoBlueIcon from "../../../assets/images/admin/video-blue-icon.png";
import VideoGrayIcon from "../../../assets/images/admin/video-gray-icon.png";
import { Button } from "react-bootstrap";
import * as userActions from "../../../redux/actions/UserActions";

const useStyles = makeStyles((theme) => ({
  root: {
    "& > *": {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
    },
  },
  table: {
    minWidth: 650,
  },
}));

const resumeStates = {
  NOT_INITIATED: "Not Initiated",
  APPROVED: "Approved",
  DECLINED: "Rejected",
  SKIPPED: "Skipped",
};

function createData(
  id,
  jobSeeker,
  regdate,
  homeDistrict,
  contact,
  premiumMember,
  videoResume,
  saarthi,
  action
) {
  return {
    id,
    jobSeeker,
    regdate,
    homeDistrict,
    contact,
    premiumMember,
    videoResume,
    saarthi,
    action,
  };
}

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

const headCells = [
  {
    id: "jobSeeker",
    numeric: false,
    disablePadding: false,
    label: "Job Seeker",
  },
  {
    id: "regdate",
    numeric: false,
    disablePadding: false,
    label: "Registration Date",
    align: "center",
  },
  {
    id: "homeDistrict",
    numeric: false,
    disablePadding: false,
    label: "Home District",
    align: "center",
  },
  {
    id: "contact",
    numeric: false,
    disablePadding: false,
    label: "Mobile Number",
    align: "center",
  },
  // {
  //   id: "videoResume",
  //   numeric: false,
  //   disablePadding: false,
  //   label: "Video Resume",
  //   align: "center",
  // },
  {
    id: "action",
    numeric: false,
    disablePadding: false,
    label: "Action",
    align: "right",
  },
];

export const VideoResumeList = (props) => {
  const query = new URLSearchParams(useLocation().search);
  let pageNumber = query.get("page"); // get page number
  // let sortValue = query.get("sort"); // get sort value
  const [page, setPage] = useState(
    JSON.parse(pageNumber) ? JSON.parse(pageNumber) : 0
  );
  const history = useHistory();
  const dispatch = useDispatch();
  const classes = useStyles();
  const [table, setTable] = useState([]);
  const [order] = React.useState("asc");
  const [orderBy] = React.useState(); // set the default sorting order on the Company Name
  const [searched, setSearched] = useState(""); // variable use for storing searching text value
  const [rows, setRows] = useState([]); // variable use for storing table data
  const [tableCount, setTableCount] = useState(0);
  const [jobSeekerCount, setJobSeekerCount] = useState(0);
  const [, setTotalCount] = useState(0); // storing total count
  const [resumeState, setResumeState] = useState(resumeStates.NOT_INITIATED);

  const fetchData = async (pageNumber, _resumeState) => {
    const video_status = _resumeState || resumeState;
    let query = {
      filter_value: 3,
    };
    if (page >= 0) {
      query.page = pageNumber ? pageNumber : page;
    }
    if (searched && searched.length) {
      query.search = searched;
    }
    // if (sort) {
    //   query.sort = sort;
    // }
    if (video_status && video_status !== "All") {
      query.video_status = video_status;
    }
    dispatch(saarthiActions.getJobseekerList(query))
      .then((response) => {
        if (response && response.value.success) {
          setTableData(response.value.data.data);
          setJobSeekerCount(response.value.data.count);
          setTableCount(response.value.data.data.length);
          setTotalCount(response.value.data.count); // get and set Total count
        }
      })
      .catch((error) => {
        console.log("error", error);
      });
  };

  const updateVideoResumeStatus = (status, _user) => {
    let formData = {
      video_status: status,
      _id: _user.id,
    };
    return dispatch(userActions.updateUserData(formData)).then((res) => {
      if (res.value.success) {
        dispatch(userActions.getUserData(_user.id));
        console.log(res.value.message);
      }
    });
  };

  const onApprove = (_user) => {
    updateVideoResumeStatus(resumeStates.APPROVED, _user);
  };

  const onReject = (_user) => {
    updateVideoResumeStatus(resumeStates.DECLINED, _user);
  };
  // // Handling sorting
  // const handleRequestSort = (event, property) => {
  //   const isAsc = orderBy === property && order === "asc";
  //   setOrder(isAsc ? "desc" : "asc");
  //   setOrderBy(property);
  // };
  /**
   * @description set Table data method to update table values
   */
  const setTableData = async (jobSeekerList) => {
    let jobseekerTable = [];
    if (jobSeekerList && jobSeekerList.length) {
      let tempArray = [...jobSeekerList];
      for (let val of tempArray) {
        let data = createData(
          val._id ? val._id : "",
          val.name
            ? val.name.charAt(0).toUpperCase() + val.name.substring(1)
            : "", // split job seeker name
          val.created_at ? new Date(val.created_at).toLocaleDateString() : "",
          val.address_home ? val.address_home : "",
          val.contact && val.contact ? val.contact : "", // get contact number
          val.is_premium ? val.is_premium : "", // get premium membership value
          val.video_resume && val.video_resume.length ? "Yes" : "No", // get video resume icon
          val.saarthi && val.saarthi.name ? val.saarthi.name : ""
        );
        jobseekerTable.push(data);
      }
    }
    setTable(jobseekerTable);
    setRows(jobseekerTable); // get table data
    setTable((state) => {
      return state;
    });
    return jobseekerTable;
  };

  // // update page count
  // const handleChange = (event, value) => {
  //   setPage(value - 1);
  // };

  // go to previous page
  const prev = (pageNumber) => {
    setPage(pageNumber);
    history.push({
      pathname: "/jobseeker-list",
      search: `?page=${pageNumber}`,
    });
  };

  // got to next page
  const next = (pageNumber, sort) => {
    setPage(pageNumber);
    history.push({
      pathname: "/jobseeker-list",
      search: `?page=${pageNumber}`,
    });
  };

  /**
   * @description method to open/close the menu options
   * @param {param} e event
   */
  const toggleMenu = (e) => {
    const dropdowns = document.getElementsByClassName("table_dropdown-content");
    const thisDropdown = e.target.nextSibling;
    if (!thisDropdown.classList.contains("show")) {
      let i;
      for (i = 0; i < dropdowns.length; i++) {
        dropdowns[i].classList.remove("show");
      }
    }
    thisDropdown.classList.toggle("show");
  };

  /* function to close the dropdown when clicked outside */
  window.onclick = function (event) {
    if (!event.target.matches(".table_dropbtn")) {
      var dropdowns = document.getElementsByClassName("table_dropdown-content");
      var i;
      for (i = 0; i < dropdowns.length; i++) {
        var openDropdown = dropdowns[i];
        if (openDropdown.classList.contains("show")) {
          openDropdown.classList.remove("show");
        }
      }
    }
  };

  const jobSeekerProfile = (e, id) => {
    history.push({ pathname: "/jobseeker-profile", search: "?user_id=" + id });
  };

  // function for handling global Search
  const handleSearch = (searchedVal) => {
    if (searchedVal !== undefined && searchedVal !== null) {
      setSearched(searchedVal);
    }
  };

  // Handling search bar cross icon
  const cancelSearch = () => {
    setSearched("");
    handleSearch();
  };

  // When Video Resume are uploaded then shown Video blue icon, otherwise shown gray icon
  // const _handleVideoIcon = (videoResume) => {
  //   if (videoResume === "No") {
  //     return <img src={VideoGrayIcon} alt="" width="22" height="22" />;
  //   }
  //   return <img src={VideoBlueIcon} alt="" width="22" height="22" />;
  // };

  useEffect(() => {
    setTable([]);
    fetchData(pageNumber);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, page, searched]);

  return (
    <>
      <div className="reg_main employer_section">
        <div className="container-fluid">
          <div className="reg_inner">
            <div className="table_menu">
              <div className="table_menu_lft">
                <p>Video Resumes : {jobSeekerCount}</p>
                {/* Premium Membership Dropdown start from here */}
                <div className="timefilterdropdown">
                  <select
                    name=""
                    id=""
                    className="form-control"
                    value={resumeState}
                    onChange={(e) => {
                      const _state = e.target.value;
                      setResumeState(_state);
                      fetchData(page, _state);
                    }}
                  >
                    <option value={"All"}>All</option>
                    <option value={resumeStates.APPROVED}>Approved</option>
                    <option value={resumeStates.DECLINED}>Rejected</option>
                    <option value={resumeStates.NOT_INITIATED}>Pending</option>
                  </select>
                </div>
              </div>
              {/* Premium Membership Dropdown start from here */}
              {/* searching-section start from here */}
              <div className="table_menu_ryt">
                {/* sort-icon-section */}
                <div className="searchbar_main">
                  <SearchBar
                    value={searched}
                    onRequestSearch={(searchVal) => handleSearch(searchVal)}
                    onCancelSearch={() => cancelSearch()}
                    className="searchbar"
                  />
                </div>
              </div>
              {/* Showing tooltip for ascending and descending icon */}
              <ReactTooltip />
              {/* searching-section end */}
            </div>
            <div className="table_box">
              <TableContainer component={Paper}>
                <Table className={classes.table} aria-label="enhanced table">
                  {/* Table Action Toolbar Start From Here */}
                  <EnhancedTableHead
                    headCells={headCells}
                    classes={classes}
                    order={order}
                    orderBy={orderBy}
                    // onRequestSort={handleRequestSort}
                    rowCount={table.length}
                  />
                  {/* Table Action Toolbar End */}
                  <TableBody>
                    {stableSort(rows, getComparator(order, orderBy)).map(
                      (row, index) => {
                        const labelId = `enhanced-table-checkbox-${index}`;
                        return (
                          <TableRow hover key={row.id}>
                            <TableCell component="th" id={labelId} scope="row">
                              {row.jobSeeker}
                            </TableCell>
                            <TableCell align="center">{row.regdate}</TableCell>
                            <TableCell align="center">
                              {row.homeDistrict}
                            </TableCell>
                            <TableCell align="center">{row.contact}</TableCell>
                            {/* <TableCell align="center">
                              {row.premiumMember === true ? "Premium" : "Free"}
                            </TableCell> */}
                            {/* <TableCell align="center">
                              {_handleVideoIcon(row.videoResume)}
                            </TableCell> */}
                            {/* <TableCell align="center">{row.saarthi}</TableCell> */}
                            <TableCell
                              align="right"
                              style={{ position: "relative" }}
                            >
                              <div className="table_dropdownbox">
                                <button
                                  type="button"
                                  className="table_moreoptns table_dropbtn"
                                  onClick={toggleMenu}
                                >
                                  <FiMoreVertical />
                                </button>
                                <div className="table_dropdownmenu table_option_menu table_dropdown-content">
                                  <ul>
                                    <li>
                                      <Button
                                        variant="link"
                                        onClick={(e) =>
                                          jobSeekerProfile(e, row.id)
                                        }
                                      >
                                        Profile
                                      </Button>
                                    </li>
                                    <li>
                                      <Button
                                        variant="link"
                                        disabled={
                                          row.video_status ===
                                          resumeStates.NOT_INITIATED
                                        }
                                        onClick={(e) => {
                                          onApprove(row);
                                        }}
                                      >
                                        Approve
                                      </Button>
                                    </li>
                                    <li>
                                      <Button
                                        variant="link"
                                        disabled={
                                          row.video_status ===
                                          resumeStates.NOT_INITIATED
                                        }
                                        onClick={(e) => {
                                          onReject(row);
                                        }}
                                      >
                                        Reject
                                      </Button>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </TableCell>
                          </TableRow>
                        );
                      }
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
              <div className={classes.root}>
                <div className="pagination">
                  <button
                    type="button"
                    onClick={() => prev(page - 1)}
                    disabled={page === 0 ? true : false}
                  >
                    Prev
                  </button>
                  <span>{page + 1}</span>
                  <button
                    type="button"
                    onClick={() => next(page + 1)}
                    disabled={tableCount === 30 ? false : true}
                  >
                    Next
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
